import { render, staticRenderFns } from "./eduClass.vue?vue&type=template&id=620c8959&"
import script from "./eduClass.vue?vue&type=script&lang=js&"
export * from "./eduClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports